import React, { Fragment, useContext, useEffect, useState } from "react";
/// React router dom
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import logo from "../../../assets/images/cricket-logo.png";
import logo1 from "../../../assets/images/whitefield-logo.png";
import { defaultTenant } from "../../../services/academicService";
import { getPublicTenantLogoByFilename } from "../../../services/publicService";
import { useSession } from "../../../context/SessionContext";

export function NavMenuToggle() {
  setTimeout(() => {
    let mainwrapper = document.querySelector("#main-wrapper");
    if (mainwrapper.classList.contains("menu-toggle")) {
      mainwrapper.classList.remove("menu-toggle");
    } else {
      mainwrapper.classList.add("menu-toggle");
    }
  }, 200);
}

const NavHader = () => {
  const [toggle, setToggle] = useState(false);
  const [logoUrl, setLogoUrl] = useState("");
  const { navigationHader, openMenuToggle, background } =
    useContext(ThemeContext);
  const userSession = useSession();
  const isSuperAdmin =
    userSession?.role === "super-admin" ||
    window.location.pathname.startsWith("/super-admin");

  const fetchLogoByFileName = async (fileName) => {
    if (!fileName) {
      setLogoUrl("");
      localStorage.removeItem("tenantLogoUrl");
      return;
    }
    try {
      const res = await getPublicTenantLogoByFilename(fileName);
      const url =
        typeof res === "string" ? res : res?.fileUrl || res?.url || "";
      if (url) {
        setLogoUrl(url);
        localStorage.setItem("tenantLogoUrl", url);
      } else {
        setLogoUrl("");
        localStorage.removeItem("tenantLogoUrl");
      }
    } catch (err) {
      console.error("Error fetching tenant logo by filename:", err);
      setLogoUrl("");
      localStorage.removeItem("tenantLogoUrl");
    }
  };

  const fetchTenantAndLogo = async () => {
    if (isSuperAdmin) {
      setLogoUrl("");
      localStorage.removeItem("tenantLogoUrl");
      return;
    }
    try {
      const res = await defaultTenant();
      const tenant = res?.defaultTenant?.tenant;
      const logoObj = tenant?.logo;
      const fileName =
        logoObj?.fileName ||
        logoObj?.filename ||
        (typeof logoObj === "string" ? logoObj : null);

      if (fileName) {
        await fetchLogoByFileName(fileName);
      } else {
        setLogoUrl("");
        localStorage.removeItem("tenantLogoUrl");
      }
    } catch (error) {
      console.error("Error loading tenant for logo:", error);
      setLogoUrl("");
      localStorage.removeItem("tenantLogoUrl");
    }
  };

  useEffect(() => {
    if (isSuperAdmin) {
      setLogoUrl("");
      localStorage.removeItem("tenantLogoUrl");
      return;
    }

    const cachedUrl = localStorage.getItem("tenantLogoUrl");
    if (cachedUrl) {
      setLogoUrl(cachedUrl);
    }

    fetchTenantAndLogo();

    const handleTenantLogoUpdated = (e) => {
      const fileName = e?.detail?.fileName;
      if (fileName) {
        fetchLogoByFileName(fileName);
      } else if (e?.detail?.logoUrl !== undefined) {
        setLogoUrl(e.detail.logoUrl || "");
      } else {
        fetchTenantAndLogo();
      }
    };

    window.addEventListener("tenant-logo-updated", handleTenantLogoUpdated);
    window.addEventListener("tenant-changed", fetchTenantAndLogo);

    return () => {
      window.removeEventListener(
        "tenant-logo-updated",
        handleTenantLogoUpdated
      );
      window.removeEventListener("tenant-changed", fetchTenantAndLogo);
    };
  }, [isSuperAdmin]);

  const displayLogo = isSuperAdmin ? logo : (logoUrl || logo);

  return (
    <div className="nav-header">
      <Link
        to={isSuperAdmin ? "/super-admin/dashboard" : "/dashboard"}
        className="brand-logo"
      >
        {background.value === "dark" || navigationHader !== "color_1" ? (
          <Fragment>
            <img
              className="logo-abbr"
              src={displayLogo}
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = logo;
              }}
              alt="Logo"
              style={{ width: 45, height: 45, objectFit: "contain", borderRadius: 6 }}
            />
            <h2
              className="brand-title"
              style={{
                // fontFamily: "'Poppins', sans-serif",
                fontWeight: 800,
                letterSpacing: "1px",
                color: "#fff",
              }}
            >
              CrickPay
            </h2>

            {/* <svg
              className="brand-title"
              xmlns="http://www.w3.org/2000/svg"
              width="122"
              height="19"
              viewBox="0 0 122 19"
              fill="none"
            >
              <path
                d="M5.3 4.3V7.175H10.925V10.9H5.3V14.075H11.675V18H0.4V0.374999H11.675V4.3H5.3ZM25.8564 0.374999C27.7064 0.374999 29.3231 0.749999 30.7064 1.5C32.1064 2.23333 33.1814 3.26667 33.9314 4.6C34.6814 5.93333 35.0564 7.45833 35.0564 9.175C35.0564 10.875 34.6731 12.3917 33.9064 13.725C33.1564 15.0583 32.0814 16.1083 30.6814 16.875C29.2981 17.625 27.6898 18 25.8564 18H18.8814V0.374999H25.8564ZM25.4814 13.675C26.9148 13.675 28.0398 13.2833 28.8564 12.5C29.6731 11.7167 30.0814 10.6083 30.0814 9.175C30.0814 7.725 29.6731 6.60833 28.8564 5.825C28.0398 5.025 26.9148 4.625 25.4814 4.625H23.7814V13.675H25.4814ZM46.8504 0.374999V10.6C46.8504 11.55 47.0671 12.2833 47.5004 12.8C47.9504 13.3167 48.6254 13.575 49.5254 13.575C50.4254 13.575 51.1004 13.3167 51.5504 12.8C52.0171 12.2667 52.2504 11.5333 52.2504 10.6V0.374999H57.1504V10.6C57.1504 12.2167 56.8087 13.6 56.1254 14.75C55.4421 15.8833 54.5087 16.7417 53.3254 17.325C52.1587 17.8917 50.8587 18.175 49.4254 18.175C47.9921 18.175 46.7087 17.8917 45.5754 17.325C44.4587 16.7417 43.5754 15.8833 42.9254 14.75C42.2921 13.6167 41.9754 12.2333 41.9754 10.6V0.374999H46.8504ZM85.2084 0.374999V18H80.3084V8.275L76.9834 18H72.8834L69.5334 8.2V18H64.6334V0.374999H70.5584L74.9834 11.825L79.3084 0.374999H85.2084ZM97.6828 0.374999V18H92.7828V0.374999H97.6828ZM121.583 18H116.683L110.158 8.15V18H105.258V0.374999H110.158L116.683 10.35V0.374999H121.583V18Z"
                fill="black"
              />
            </svg> */}
          </Fragment>
        ) : (
          <Fragment>
            {/* <svg
              className="logo-abbr"
              width="57"
              height="57"
              viewBox="0 0 57 57"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_4_96)">
                <path
                  d="M28.5 38.727L10.0549 29.7293V41.6065L28.501 49.7984L46.9469 41.6065V29.7283L28.5 38.727Z"
                  fill="white"
                />
                <path
                  d="M57 21.1042L28.5001 7.20154L0 21.1042L28.5001 35.0069L50.2909 24.3771V36.7516H53.6344V22.746L57 21.1042Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_4_96">
                  <rect width="57" height="57" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <svg
              className="brand-title"
              xmlns="http://www.w3.org/2000/svg"
              width="122"
              height="19"
              viewBox="0 0 122 19"
              fill="none"
            >
              <path
                d="M5.3 4.3V7.175H10.925V10.9H5.3V14.075H11.675V18H0.4V0.374999H11.675V4.3H5.3ZM25.8564 0.374999C27.7064 0.374999 29.3231 0.749999 30.7064 1.5C32.1064 2.23333 33.1814 3.26667 33.9314 4.6C34.6814 5.93333 35.0564 7.45833 35.0564 9.175C35.0564 10.875 34.6731 12.3917 33.9064 13.725C33.1564 15.0583 32.0814 16.1083 30.6814 16.875C29.2981 17.625 27.6898 18 25.8564 18H18.8814V0.374999H25.8564ZM25.4814 13.675C26.9148 13.675 28.0398 13.2833 28.8564 12.5C29.6731 11.7167 30.0814 10.6083 30.0814 9.175C30.0814 7.725 29.6731 6.60833 28.8564 5.825C28.0398 5.025 26.9148 4.625 25.4814 4.625H23.7814V13.675H25.4814ZM46.8504 0.374999V10.6C46.8504 11.55 47.0671 12.2833 47.5004 12.8C47.9504 13.3167 48.6254 13.575 49.5254 13.575C50.4254 13.575 51.1004 13.3167 51.5504 12.8C52.0171 12.2667 52.2504 11.5333 52.2504 10.6V0.374999H57.1504V10.6C57.1504 12.2167 56.8087 13.6 56.1254 14.75C55.4421 15.8833 54.5087 16.7417 53.3254 17.325C52.1587 17.8917 50.8587 18.175 49.4254 18.175C47.9921 18.175 46.7087 17.8917 45.5754 17.325C44.4587 16.7417 43.5754 15.8833 42.9254 14.75C42.2921 13.6167 41.9754 12.2333 41.9754 10.6V0.374999H46.8504ZM85.2084 0.374999V18H80.3084V8.275L76.9834 18H72.8834L69.5334 8.2V18H64.6334V0.374999H70.5584L74.9834 11.825L79.3084 0.374999H85.2084ZM97.6828 0.374999V18H92.7828V0.374999H97.6828ZM121.583 18H116.683L110.158 8.15V18H105.258V0.374999H110.158L116.683 10.35V0.374999H121.583V18Z"
                fill="black"
              />
            </svg> */}
            <img
              className="logo-abbr"
              src={displayLogo}
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = logo;
              }}
              alt="Logo"
              style={{ width: 45, height: 45, objectFit: "contain", borderRadius: 6 }}
            />
            <h2
              className="brand-title"
              style={{
                // fontFamily: "'Poppins', sans-serif",
                fontWeight: 800,
                letterSpacing: "1px",
                color: "#fff",
              }}
            >
              CrickPay
            </h2>
          </Fragment>
        )}
      </Link>

      <div
        className="nav-control"
        onClick={() => {
          setToggle(!toggle);
          openMenuToggle();
          NavMenuToggle();
        }}
      >
        <div className={`hamburger ${toggle ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;
